import { Separator } from '../ui/separator';
import { CampaignReportData } from '../../types/campaignReport';
import { OverviewTab } from './tabs/OverviewTab';
import { FunnelTab } from './tabs/FunnelTab';
import { RevenueTab } from './tabs/RevenueTab';
import { RetentionTab } from './tabs/RetentionTab';
import { HaloTab } from './tabs/HaloTab';
import { TimeOfDayTab } from './tabs/TimeOfDayTab';
import { FeedbackTab } from './tabs/FeedbackTab';

interface ReportTabsProps {
  data: CampaignReportData;
}

export function ReportTabs({ data }: ReportTabsProps) {
  return (
    <div className="w-full space-y-12">
      {/* Overview Section */}
      <OverviewTab data={data} />
      <Separator className="my-8" />

      {/* Funnel Section */}
      <FunnelTab data={data} />
      <Separator className="my-8" />

      {/* Revenue Section */}
      <RevenueTab data={data} />
      <Separator className="my-8" />

      {/* Retention Section */}
      <RetentionTab data={data} />
      <Separator className="my-8" />

      {/* Halo Effect Section */}
      <HaloTab data={data} />
      <Separator className="my-8" />

      {/* Time of Day Section */}
      <TimeOfDayTab data={data} />
      <Separator className="my-8" />

      {/* Feedback Section */}
      <FeedbackTab data={data} />
    </div>
  );
}
